import { get, post } from '@/api/index';
export const videoinfo = params => get(`/api/course/v1/detail/videoinfo`, params);//直播
export const report = params => get(`/api/watchtime/v1/report`, params);//上报
export const downFile = params => get(`/api/course/v1/detail/materialinfo`, params); //下载
export const lessonList = params => get(`/api/course/v1/detail/lessonlist`, params); // 课件列表
export const previewvideo = params => get(`/api/course/v1/detail/previewvideo`, params); // 课件列表
export const toKey = params => get(`/api/login/v1/sessionkey`, params); // 公共获取sid
export const ebookinfo = params => get(`/api/course/v1/detail/ebookinfo`, params); //下载
